/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { isAuthenticatedUser } from 'js/lib/user';

import { ENTERPRISE_ADMIN_NAVBAR_HEIGHT_PX } from 'bundles/enterprise-admin-navigation/constants';
import type { ThirdPartyOrganization } from 'bundles/enterprise-admin/types';

import AdminHeaderAndNav from './AdminHeaderAndNav';

type Props = {
  thirdPartyOrganization: ThirdPartyOrganization;
  adminRoleType?: string;
  showCoach: boolean;
  toggleCoach: () => void;
};

export const AdminAuthNavigation: React.FC<Props> = ({
  thirdPartyOrganization,
  adminRoleType,
  showCoach,
  toggleCoach,
}) => {
  return (
    <div
      css={css`
        min-height: ${ENTERPRISE_ADMIN_NAVBAR_HEIGHT_PX}px;
      `}
    >
      <nav
        className="rc-AdminAuthNavigation"
        css={css`
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          z-index: 3000;
        `}
      >
        {isAuthenticatedUser() && (
          <AdminHeaderAndNav
            showCoach={showCoach}
            toggleCoach={toggleCoach}
            thirdPartyOrganization={thirdPartyOrganization}
            adminRoleType={adminRoleType}
          />
        )}
      </nav>
    </div>
  );
};
